import { Fragment } from 'react';
import { Link } from 'react-router';
import { useTranslation } from '@/shared/i18n/use-translation';
import { Breadcrumb } from '@/shared/ui/breadcrumb/breadcrumb';
import { BreadcrumbItem } from '@/shared/ui/breadcrumb/breadcrumb-item';
import { BreadcrumbLink } from '@/shared/ui/breadcrumb/breadcrumb-link';
import { BreadcrumbList } from '@/shared/ui/breadcrumb/breadcrumb-list';
import { BreadcrumbPage } from '@/shared/ui/breadcrumb/breadcrumb-page';
import { BreadcrumbSeparator } from '@/shared/ui/breadcrumb/breadcrumb-separator';
import { useCrumbs } from './use-crumbs';

/** Where you are, from the routes' `handle.crumb`; every crumb but the last is a link. */
export function HeaderBreadcrumb() {
  const { t } = useTranslation();
  const crumbs = useCrumbs();
  return (
    <Breadcrumb className="min-w-0" aria-label={t('Breadcrumb')}>
      <BreadcrumbList>
        {crumbs.map((crumb, index) => (
          <Fragment key={crumb.id}>
            {index > 0 && <BreadcrumbSeparator />}
            <BreadcrumbItem>
              {index === crumbs.length - 1 ? (
                <BreadcrumbPage>{t(crumb.label)}</BreadcrumbPage>
              ) : (
                <BreadcrumbLink render={<Link to={crumb.to} />}>{t(crumb.label)}</BreadcrumbLink>
              )}
            </BreadcrumbItem>
          </Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
